/* eslint-disable max-len */
import React from 'react'
import './index.css'
function CustomOverLay({Active,text,classKey}) {
    return (
        <>{Active &&<div  className={classKey}>
            <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12 mb-4 spin-animation"></div>
            {/* <h2 class="text-center text-white text-xl font-semibold">Loading...</h2> */}
            <p className="w-1/3 text-center text-white">{text||'This may take a few seconds, please don`t close this page.'}</p>
        </div>}</>

    )
}

export default CustomOverLay;